import { ROUTE_LOGISTIC_VEHICLES } from '@@partner:config/routes'
import { usePartner } from '@@partner:helpers/hooks/auth'
import React from 'react'
import { AddOutline, ListOutline } from 'react-ionicons'
import { generatePath, NavLink } from 'react-router-dom'
import { Navbar, Nav } from 'rsuite'
import AddVehicleModal from './AddVehicleModal'

export default function VehiclesSubMenu () {
  const [ openCreateModel, setOpenCreateModel ] = React.useState(false)

  const { brandSlug } = usePartner()
  

  return (
    <div>
      <Navbar>
        <Nav>
          <Nav.Item
            icon={<ListOutline />}
            as={NavLink}
            to={generatePath(ROUTE_LOGISTIC_VEHICLES, {
              brandSlug
            })}
          >
              Список транспорта
          </Nav.Item>
          <Nav.Item
            icon={<AddOutline />}
            onClick={() => setOpenCreateModel(true)}
          >
              Создать транспорт
          </Nav.Item>
        </Nav>
      </Navbar>
      <AddVehicleModal
        isOpen={openCreateModel}
        onClose={() => setOpenCreateModel(false)}
      />
    </div>
  )
}